import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Gift, BookOpen, Play, Sparkles, Heart, MessageCircle, Brain } from 'lucide-react';
export function FreeResources() {
  const guides = [{
    title: 'Ghid Practic despre Emoții',
    subtitle: 'Înțelege ce simți',
    icon: <Heart className="w-8 h-8" strokeWidth={1.5} data-id="element-111" />,
    gradient: 'from-plum via-plum-light to-plum',
    accent: 'bg-orange/20'
  }, {
    title: 'Ghid de Comunicare Eficientă',
    subtitle: 'Spune ce gândești',
    icon: <MessageCircle className="w-8 h-8" strokeWidth={1.5} data-id="element-112" />,
    gradient: 'from-plum-light via-violet to-plum-light',
    accent: 'bg-cream/20'
  }, {
    title: 'Depășirea Limitelor Mentale',
    subtitle: 'Eliberează-te',
    icon: <Brain className="w-8 h-8" strokeWidth={1.5} data-id="element-113" />,
    gradient: 'from-violet via-plum to-violet',
    accent: 'bg-orange/15'
  }];
  return <section className="bg-plum/5 py-12 md:py-20 relative overflow-hidden" data-id="element-114">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-plum/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-115"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-orange/5 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-116"></div>

      <div className="max-w-[1100px] mx-auto px-6 md:px-8 relative z-10" data-id="element-117">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-118">
          {/* Left: Rich Bundle Visual */}
          <FadeIn delay={0.1} data-id="element-119">
            <div className="relative flex justify-center lg:justify-end" data-id="element-120">
              <div className="relative w-[340px] md:w-[420px] h-[360px] md:h-[420px]" data-id="element-121">
                {/* Glow behind bundle */}
                <div className="absolute inset-0 bg-gradient-to-br from-plum/10 via-violet/10 to-orange/10 rounded-[40px] blur-2xl scale-110" data-id="element-122"></div>

                {/* Guide 1 - back left */}
                <div className="absolute left-0 bottom-12 -rotate-8 hover:-rotate-3 hover:-translate-y-3 transition-all duration-500 z-10 group cursor-pointer" data-id="element-123">
                  <div className={`w-[140px] md:w-[165px] h-[200px] md:h-[235px] bg-gradient-to-br ${guides[0].gradient} rounded-xl shadow-card-hover relative overflow-hidden`} data-id="element-124">
                    {/* Spine */}
                    <div className="absolute left-0 top-0 bottom-0 w-[6px] bg-gradient-to-b from-white/10 to-black/20 rounded-l-xl" data-id="element-125"></div>
                    {/* Top decorative band */}
                    <div className="absolute top-0 left-0 right-0 h-16 bg-gradient-to-b from-white/10 to-transparent" data-id="element-126"></div>
                    {/* Decorative pattern */}
                    <div className="absolute top-4 right-4 w-20 h-20 border border-cream/10 rounded-full" data-id="element-127"></div>
                    <div className="absolute top-8 right-8 w-12 h-12 border border-cream/10 rounded-full" data-id="element-128"></div>
                    {/* Icon */}
                    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-[60%]" data-id="element-129">
                      <div className={`w-16 h-16 rounded-full ${guides[0].accent} backdrop-blur-sm flex items-center justify-center border border-cream/20 group-hover:scale-110 transition-transform duration-300`} data-id="element-130">
                        <div className="text-cream/80" data-id="element-131">{guides[0].icon}</div>
                      </div>
                    </div>
                    {/* Title area */}
                    <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/50 via-black/20 to-transparent" data-id="element-132">
                      <p className="text-cream/60 text-[9px] font-poppins uppercase tracking-wider mb-1" data-id="element-133">
                        {guides[0].subtitle}
                      </p>
                      <p className="text-cream text-[11px] md:text-[12px] font-poppins font-semibold leading-tight" data-id="element-134">
                        {guides[0].title}
                      </p>
                    </div>
                    {/* Shine effect */}
                    <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-white/8 to-transparent" data-id="element-135"></div>
                  </div>
                </div>

                {/* Guide 2 - center front */}
                <div className="absolute left-1/2 -translate-x-1/2 bottom-14 rotate-0 hover:-translate-y-3 transition-all duration-500 z-20 group cursor-pointer" data-id="element-136">
                  <div className={`w-[140px] md:w-[165px] h-[200px] md:h-[235px] bg-gradient-to-br ${guides[1].gradient} rounded-xl shadow-card-hover relative overflow-hidden ring-1 ring-cream/10`} data-id="element-137">
                    <div className="absolute left-0 top-0 bottom-0 w-[6px] bg-gradient-to-b from-white/10 to-black/20 rounded-l-xl" data-id="element-138"></div>
                    <div className="absolute top-0 left-0 right-0 h-16 bg-gradient-to-b from-white/10 to-transparent" data-id="element-139"></div>
                    <div className="absolute top-4 right-4 w-20 h-20 border border-cream/10 rounded-full" data-id="element-140"></div>
                    <div className="absolute top-8 right-8 w-12 h-12 border border-cream/10 rounded-full" data-id="element-141"></div>
                    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-[60%]" data-id="element-142">
                      <div className={`w-16 h-16 rounded-full ${guides[1].accent} backdrop-blur-sm flex items-center justify-center border border-cream/20 group-hover:scale-110 transition-transform duration-300`} data-id="element-143">
                        <div className="text-cream/80" data-id="element-144">{guides[1].icon}</div>
                      </div>
                    </div>
                    <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/50 via-black/20 to-transparent" data-id="element-145">
                      <p className="text-cream/60 text-[9px] font-poppins uppercase tracking-wider mb-1" data-id="element-146">
                        {guides[1].subtitle}
                      </p>
                      <p className="text-cream text-[11px] md:text-[12px] font-poppins font-semibold leading-tight" data-id="element-147">
                        {guides[1].title}
                      </p>
                    </div>
                    <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-white/8 to-transparent" data-id="element-148"></div>
                  </div>
                </div>

                {/* Guide 3 - back right */}
                <div className="absolute right-0 bottom-12 rotate-8 hover:rotate-3 hover:-translate-y-3 transition-all duration-500 z-10 group cursor-pointer" data-id="element-149">
                  <div className={`w-[140px] md:w-[165px] h-[200px] md:h-[235px] bg-gradient-to-br ${guides[2].gradient} rounded-xl shadow-card-hover relative overflow-hidden`} data-id="element-150">
                    <div className="absolute left-0 top-0 bottom-0 w-[6px] bg-gradient-to-b from-white/10 to-black/20 rounded-l-xl" data-id="element-151"></div>
                    <div className="absolute top-0 left-0 right-0 h-16 bg-gradient-to-b from-white/10 to-transparent" data-id="element-152"></div>
                    <div className="absolute top-4 right-4 w-20 h-20 border border-cream/10 rounded-full" data-id="element-153"></div>
                    <div className="absolute top-8 right-8 w-12 h-12 border border-cream/10 rounded-full" data-id="element-154"></div>
                    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-[60%]" data-id="element-155">
                      <div className={`w-16 h-16 rounded-full ${guides[2].accent} backdrop-blur-sm flex items-center justify-center border border-cream/20 group-hover:scale-110 transition-transform duration-300`} data-id="element-156">
                        <div className="text-cream/80" data-id="element-157">{guides[2].icon}</div>
                      </div>
                    </div>
                    <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/50 via-black/20 to-transparent" data-id="element-158">
                      <p className="text-cream/60 text-[9px] font-poppins uppercase tracking-wider mb-1" data-id="element-159">
                        {guides[2].subtitle}
                      </p>
                      <p className="text-cream text-[11px] md:text-[12px] font-poppins font-semibold leading-tight" data-id="element-160">
                        {guides[2].title}
                      </p>
                    </div>
                    <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-white/8 to-transparent" data-id="element-161"></div>
                  </div>
                </div>

                {/* Video badge - floating top right */}
                <div className="absolute -right-3 md:right-2 top-2 z-30 hover:-translate-y-2 hover:scale-105 transition-all duration-300 cursor-pointer group" data-id="element-162">
                  <div className="w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-gradient-to-br from-orange to-amber shadow-btn-orange flex items-center justify-center border-2 border-cream relative overflow-hidden" data-id="element-163">
                    <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-white/10" data-id="element-164"></div>
                    <Play className="w-7 h-7 md:w-8 md:h-8 text-white fill-white/90 ml-0.5 relative z-10 group-hover:scale-110 transition-transform" strokeWidth={1.5} data-id="element-165" />
                  </div>
                  <p className="text-[10px] md:text-[11px] font-poppins font-semibold text-plum text-center mt-2 leading-tight" data-id="element-166">
                    Materiale
                    <br data-id="element-167" />
                    Video
                  </p>
                </div>

                {/* Decorative sparkles */}
                <div className="absolute -left-4 top-8 z-30" data-id="element-168">
                  <Sparkles className="w-5 h-5 text-orange/40" data-id="element-169" />
                </div>
                <div className="absolute right-16 -top-2 z-30" data-id="element-170">
                  <Sparkles className="w-4 h-4 text-plum/30" data-id="element-171" />
                </div>

                {/* Bundle badge - bottom center */}
                <div className="absolute left-1/2 -translate-x-1/2 bottom-0 z-30" data-id="element-172">
                  <div className="bg-gradient-to-r from-plum to-plum-light text-cream px-6 py-2.5 rounded-full shadow-card-hover flex items-center gap-2 border border-cream/10" data-id="element-173">
                    <Gift className="w-4 h-4 text-orange" strokeWidth={2} data-id="element-174" />
                    <span className="font-poppins font-semibold text-[12px] uppercase tracking-wider" data-id="element-175">
                      Materiale Cadou
                    </span>
                    <Sparkles className="w-4 h-4 text-orange" strokeWidth={2} data-id="element-176" />
                  </div>
                </div>
              </div>
            </div>
          </FadeIn>

          {/* Right: Text */}
          <div data-id="element-177">
            <FadeIn data-id="element-178">
              <div className="w-16 h-16 bg-plum/10 rounded-full flex items-center justify-center mb-6" data-id="element-179">
                <Gift className="w-8 h-8 text-plum" strokeWidth={1.5} data-id="element-180" />
              </div>

              <span className="font-poppins font-semibold uppercase tracking-[0.15em] text-[13px] text-plum mb-4 block" data-id="element-181">
                CADOURI PENTRU TINE
              </span>

              <h2 className="text-[32px] md:text-[42px] font-medium leading-[1.15] mb-6" data-id="element-182">
                3 Ghiduri Plus Materiale Video Gratuite
              </h2>

              <p className="text-[17px] md:text-[19px] text-plum-light leading-[1.65] mb-6 max-w-[500px]" data-id="element-183">
                Îți dăruiesc trei ghiduri practice despre emoții, comunicare și
                depășirea limitelor mentale. Plus acces la înregistrări din
                traininguri și seminarii online susținute de-a lungul anilor.
              </p>

              <ul className="space-y-3 mb-10 max-w-[500px]" data-id="element-184">
                <li className="flex items-center gap-3 text-[15px] text-plum-light" data-id="element-185">
                  <div className="w-6 h-6 rounded-full bg-orange/10 flex items-center justify-center shrink-0" data-id="element-186">
                    <BookOpen className="w-3.5 h-3.5 text-orange" strokeWidth={2} data-id="element-187" />
                  </div>
                  Ghid Practic despre Emoții
                </li>
                <li className="flex items-center gap-3 text-[15px] text-plum-light" data-id="element-188">
                  <div className="w-6 h-6 rounded-full bg-orange/10 flex items-center justify-center shrink-0" data-id="element-189">
                    <BookOpen className="w-3.5 h-3.5 text-orange" strokeWidth={2} data-id="element-190" />
                  </div>
                  Ghid de Comunicare Eficientă
                </li>
                <li className="flex items-center gap-3 text-[15px] text-plum-light" data-id="element-191">
                  <div className="w-6 h-6 rounded-full bg-orange/10 flex items-center justify-center shrink-0" data-id="element-192">
                    <BookOpen className="w-3.5 h-3.5 text-orange" strokeWidth={2} data-id="element-193" />
                  </div>
                  Depășirea Limitelor Mentale
                </li>
                <li className="flex items-center gap-3 text-[15px] text-plum-light" data-id="element-194">
                  <div className="w-6 h-6 rounded-full bg-orange/10 flex items-center justify-center shrink-0" data-id="element-195">
                    <Play className="w-3.5 h-3.5 text-orange fill-orange" strokeWidth={2} data-id="element-196" />
                  </div>
                  Materiale video din traininguri și seminarii
                </li>
              </ul>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-197">
              <a href="https://wa.me/40744377234" target="_top" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 rounded-lg font-poppins font-semibold text-[16px] transition-all duration-200 hover:scale-[1.02] cursor-pointer no-underline bg-orange text-white hover:bg-orange-hover hover:shadow-btn-orange" data-id="element-198">
                Vreau Cadourile Mele
              </a>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}